<template>
  <div />
  <!-- <div class="mt-3">
    <router-link to='/calendar/manage-time-and-priorities'>manage-time-and-priorities</router-link> |
    <router-link to='/calendar/manage-week'>manage-week</router-link>
  </div> -->
</template>

<script>
// TODO: Delete?

export default {
  name: "CalendarPage",
};
</script>
